export default __webpack_public_path__ + "static/media/Brow_3_C3.0bf4fcc8.svg";